// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1g96pd34>div{border-radius:var(--ds-border-radius-200,8px)}\n._1qo3n8v0>div{border:var(--_vzvmm2)}", ""]);
// Exports
module.exports = exports;
